// extracted by mini-css-extract-plugin
export default {"wrapper":"ky8lgzP","togglerWrapper":"GZm_X1n"};